



























































































































































































import { fetchMID } from './fetchMID';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
import store from '@/store';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import { SubAccion } from '../../views/base/VariablesPermisos';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormAsignarEsquema extends Vue {
  [x: string]: any;
  @Prop({}) edited: any;
  @Prop({}) asignarEsquema!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ required: true }) clienteId: any;
  @Prop({
    default: () => ({ id: 0, nombre: '', estado: EstadoEntidad.Activo }),
  })
  @Prop({})
  cliente: any;
  @Prop({}) clientesAll!: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  esquemaBd: any[] = [];

  formFields: {
    endPoint: any;
    clientes: any;
  } = {
    endPoint: {
      label: 'EndPoint',
      value: '',
      items: this.asignarEsquema,
    },
    clientes: {
      label: 'clientes',
      value: 0,
      items: this.clientesAll,
      formatItem: (item: { nombre: any; rut: any }) =>
        `${item.nombre} [${item.rut}]`,
    },
  };

  async getEsquemaCliente() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.formFields.clientes.value.toString() },
      'mid_cliente/GetEsquemaCliente'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          data.data.data.forEach((e: any) => {
            const esquemaBdArray = data.data.data.map(
              (item: { esquema_bd: any }) => item.esquema_bd
            );
            this.esquemaBd = esquemaBdArray;
          });
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    const clienteMid = sessionStorage.getItem('clienteMid');

    // Si hay un valor, busque el ID correspondiente en la lista de clientes
    if (clienteMid) {
      const clienteId = parseInt(clienteMid, 10);
      const clienteEncontrado = this.clientesAll.find(
        (cliente: { id: number }) => cliente.id === clienteId
      );

      if (clienteEncontrado) {
        // Seleccione el cliente encontrado
        this.formFields.clientes.value = clienteEncontrado.id;
      }
    }
  }

  onModelUpdated() {}

  onSelectionChanged(id: any) {}

  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.AsignacionEsquemas;

  // Declarar todas las posibles subAcciones
  asociarEnpoint: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  asociarVehiculos: PermisoAccionVm = {
    accion: 'Crear - Asociar Vehículos',
    visible: true,
    step: 2,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };
  // Globales
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = false;
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  datoEditado: any = {};

  async grabarEdicion() {
    if (this.formFields.endPoint.value != '') {
      await this.insertar();
      this.closeModal(false);
    } else {
      this.$snotify.error('Por favor seleccion un endpoint valido', {
        timeout: 3000,
      });
    }
  }

  async insertar() {
    let self = this;
    return fetchMID(
      {
        esquema: this.esquemaBd,
        id: this.formFields.endPoint.value.toString(),
        clienteid: this.formFields.clientes.value.toString(),
        userid: store.state.userId.toString(),
      },
      'mid_cliente/PostAsignarEsquema'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualizacion exitosa', { timeout: 3000 });
          this.closeModal(true);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
    /* .finally(() => {
                      return null;
                    }); */
  }
  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivP').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('datoCreado', true);
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset(); //Reset Validaciones
    this.dialog = false;

    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';

    this.show = false;
    this.guardarInactivo = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
  continuar() {
    if (this.cliente != '') {
      this.getEsquemaCliente();
      this.$validator.validateAll().then(resultado => {
        if (resultado) {
          document.getElementById('cardDivP').scrollIntoView(true);
          if (this.e1 == 2) {
            this.grabarEdicion();
            this.btnText = 'Guardar';
            this.btnClass = 'btn-grabar';
          } else {
            this.e1++;
            this.getEsquemaCliente();
          }
        }
      });
    } else {
      this.$snotify.error('Por favor seleccione un Cliente valido', {
        timeout: 3000,
      });
    }
  }

  volver() {
    this.e1 -= 1;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    document.getElementById('cardDivP').scrollIntoView(true);
  }

  cierraMenuPerfil() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
  selectedcliente() {
    return this.formFields.clientes.items.find(
      (item: { id: any }) => item.id === this.cliente
    );
  }
}
